module.exports = __webpack_public_path__ + "static/app-shot-n-1-2-63b57fb73499d798f43b1e6a0c15f450.png";